module.exports = "<div *ngIf=\"message\" class=\"m-alert m-alert--outline alert alert-{{message.type}} alert-dismissible\" role=\"alert\">\r\n\t<button type=\"button\" class=\"close\" data-dismiss=\"alert\" aria-label=\"Close\"></button>\r\n\t<span>{{message.text}}</span>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/auth/_directives/alert.component.html
// module id = ./src/app/auth/_directives/alert.component.html
// module chunks = main